export const spotsUrl = 'spot-fences/';
export const publicSpotsUrl = (shareLinkId: string) => `external/share-link/${shareLinkId}/spot-fences/`;
